module.exports = __webpack_public_path__ + "img/reg_tel1.be794bf3.png";